import { Track } from '../types/audio'

export const sampleTracks: Track[] = [
  {
    id: '1',
    title: 'Acoustic Breeze',
    artist: 'Benjamin Tissot',
    duration: '2:37',
    url: '/audio/acoustic-breeze.mp3',
    coverArt: '/images/acoustic-breeze.jpg'
  },
  {
    id: '2',
    title: 'Creative Minds',
    artist: 'Benjamin Tissot',
    duration: '2:27',
    url: '/audio/creative-minds.mp3',
    coverArt: '/images/creative-minds.jpg'
  },
  {
    id: '3',
    title: 'Summer',
    artist: 'Benjamin Tissot',
    duration: '3:35',
    url: '/audio/summer.mp3',
    coverArt: '/images/summer.jpg'
  }
]

// These tracks are from Bensound.com and are free to use
// in non-commercial projects with attribution 